import { render } from "./OlabUser.vue?vue&type=template&id=d4764e8a&scoped=true"
import script from "./OlabUser.vue?vue&type=script&lang=js"
export * from "./OlabUser.vue?vue&type=script&lang=js"

import "./OlabUser.vue?vue&type=style&index=0&id=d4764e8a&scoped=true&lang=css"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4764e8a"]])

export default __exports__